import React from "react";

import { Button, Dialog, DialogTrigger, makeStyles, Toolbar, ToolbarGroup } from "@fluentui/react-components";
import { Add16Filled, Add16Regular, ArrowClockwise16Filled, ArrowClockwise16Regular, Edit16Filled, Edit16Regular, PeopleEdit16Filled, PeopleEdit16Regular, bundleIcon } from "@fluentui/react-icons";

import { useDeviceDrawerStore } from "../store/DeviceDrawerStore";
import { useDeviceGridStore } from "../store/DeviceGridStore";
import { useDevicesContext } from "../context/DevicesContext";
import { useDeviceDialogStore } from "../store/DeviceDialogStore";
import DeviceAssignmentDialog from "./DeivceAssignmentDialog";

const AddBundle = bundleIcon(Add16Filled, Add16Regular);
const AssignBundle = bundleIcon(PeopleEdit16Filled, PeopleEdit16Regular);
const EditBundle = bundleIcon(Edit16Filled, Edit16Regular);
const RefreshBundle = bundleIcon(ArrowClockwise16Filled, ArrowClockwise16Regular);

const useStyles = makeStyles({
    toolbar: {
        justifyContent: "end",
        padding: "5px 0px",
    }
});

export default function DeviceToolbar() {
    const styles = useStyles();

    const { refetchListOption, refetchDevices, isListOptionFetching, isDevicesFetching } = useDevicesContext();
    const { openNew, openEdit } = useDeviceDrawerStore();
    const { isOpen, openAssignment } = useDeviceDialogStore();
    const { selectedDevices } = useDeviceGridStore();

    const handleRefresh = React.useCallback(() => {
        refetchListOption();
        refetchDevices();
    }, [refetchListOption, refetchDevices]);

    return (
        <Toolbar
            aria-label="Device toolbar"
            className={styles.toolbar}
            size="medium"
        >
            <ToolbarGroup>
                <Button
                    aria-label="Add"
                    shape="circular"
                    appearance="subtle"
                    icon={<AddBundle />}
                    onClick={openNew}
                    disabled={isListOptionFetching || isDevicesFetching}
                >Add</Button>

                <Dialog open={isOpen} onOpenChange={openAssignment} modalType="modal">
                    <DialogTrigger disableButtonEnhancement>
                    <Button
                        aria-label="Assign"
                        shape="circular"
                        appearance="subtle"
                        icon={<AssignBundle />}
                        onClick={openAssignment}
                        disabled={selectedDevices.length < 1}
                    >Assign</Button>
                    </DialogTrigger>
                    <DeviceAssignmentDialog />
                </Dialog>

                <Button
                    aria-label="Edit"
                    shape="circular"
                    appearance="subtle"
                    icon={<EditBundle />}
                    onClick={() => openEdit(selectedDevices[0])}
                    disabled={selectedDevices.length !== 1}
                >Edit</Button>

                <Button
                    aria-label='Refresh'
                    shape='circular'
                    appearance='subtle'
                    icon={<RefreshBundle />}
                    onClick={handleRefresh}
                    disabled={isListOptionFetching || isDevicesFetching}
                >Refresh</Button>
            </ToolbarGroup>
        </Toolbar>
    );
}